import { useEffect, useState } from 'react';
import client from '../../api/client';
import formatDate from '../../utils/formatDate';

export default function ArchivePage() {
	const [posts, setPosts] = useState([]);
	const fetchData = async () => {
		const { data } = await client.get('/blog/all');
		if ({ data }) {
			setPosts(data.blogPosts);
		}
	};
	useEffect(() => {
		fetchData();
	}, []);
	return (
		<div className='bg-white py-24 sm:py-32'>
			<div className='mx-auto max-w-7xl px-6 lg:px-8'>
				<div className='mx-auto max-w-2xl'>
					<h2 className='text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
						Archives
					</h2>
					<p className='mt-2 text-lg leading-8 text-gray-600'>
						View all our blog posts
					</p>
					<div className='mt-10 space-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16'>
						{posts &&
							posts.map((post) => (
								<article
									key={post.id}
									className='flex max-w-xl flex-col items-start justify-between'
								>
									<div className='flex items-center gap-x-4 text-xs'>
										<img
											src={post?.img}
											alt=''
											className='h-10 w-10 rounded-full bg-gray-50'
										/>
										<time
											dateTime={post.createdAt}
											className='text-gray-500'
										>
											{formatDate(post.createdAt)}
										</time>
									</div>
									<div className='group relative'>
										<h3 className='mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600'>
											<a href={'/blog/' + post._id}>
												<span className='absolute inset-0' />
												{post.title}
											</a>
										</h3>
										<p className='mt-5 line-clamp-3 text-sm leading-6 text-gray-600'>
											{post.description}
										</p>
									</div>
									<div className='relative mt-8 flex items-center gap-x-4'>
										{/* <div className='text-sm leading-6'>
											<p className='font-semibold text-gray-900'>
												<a href={'/blog/' + post._id}>
													<span className='absolute inset-0' />
													Andrew Keiser
												</a>
											</p>
											<p className='text-gray-600'>{post?.author?.role}</p>
										</div> */}
									</div>
								</article>
							))}
					</div>
				</div>
			</div>
		</div>
	);
}
